import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { MetricsComponent } from './metrics.component';
import { AuthGuardService } from '../authentication/auth-guard.service';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MetricsDetailComponent } from './metrics-detail/metrics-detail.component';


const routes: Routes = [
  // { path: '', redirectTo: '/metrics', pathMatch: 'full'},
  { path: 'metrics', component: MetricsComponent, canActivate: [AuthGuardService]},
  { path: 'metrics-details', component: MetricsDetailComponent, canActivate: [AuthGuardService]}               
];


@NgModule({
  declarations: [
    MetricsComponent,
    MetricsDetailComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    NgxChartsModule,
    RouterModule.forChild(routes),

  ]
})
export class MetricsModule { }
